import { markActionComplete } from 'user-context/onboarding';
export const markTaskComplete = (completeActionKey, options) => {
  return markActionComplete(completeActionKey, Object.assign({}, options, {
    source: 'onboarding-tours'
  }));
};